module.exports = __webpack_public_path__ + "media/images/number_1-4c594b8d902d75baac1b1500a2d90352.png";